import { useEffect, useRef } from 'react';

// Thin bar at the top of the viewport showing how far through the article you are.
export default function ReadingProgress({ target }) {
  const barRef = useRef(null);

  useEffect(() => {
    let raf = 0;
    const update = () => {
      raf = 0;
      const el = target.current;
      const bar = barRef.current;
      if (!el || !bar) return;
      const { top, height } = el.getBoundingClientRect();
      const total = height - window.innerHeight;
      const p = total > 0 ? Math.min(1, Math.max(0, -top / total)) : 1;
      bar.style.transform = `scaleX(${p})`;
    };
    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [target]);

  return <div ref={barRef} className="progress" aria-hidden="true" />;
}
